import { useEffect } from 'react';

import useApi from 'utils/hooks/api/useApi';
import { ALERT_VARIANTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import { useTranslation } from 'react-i18next';
import { LOCALIZATION_PAGES, API_ENDPOINTS } from 'utils/constants';
import { HTTP_VERBS } from 'utils/constants';

const useScreeningUpdateSeatingType = id => {
  const { t } = useTranslation(LOCALIZATION_PAGES.SCREENINGS);
  const { showNotification } = useRoot();
  const path = `${API_ENDPOINTS.SCREENINGS}/${id}/seating-type`;

  const [
    {
      result: updateScreeningSeatingTypeResult,
      loading: loadingUpdateScreeningSeatingType,
      error: errorScreeningSeatingType,
      setResult: setUpdateScreeningSeatingResult,
    },
    updateScreeningSeatingType,
  ] = useApi(path, {
    initialFetch: false,
    verb: HTTP_VERBS.PUT,
  });

  useEffect(() => {
    if (errorScreeningSeatingType) {
      showNotification(
        {
          message: t('change_seating_error'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [errorScreeningSeatingType, showNotification, t]);

  useEffect(() => {
    if (updateScreeningSeatingTypeResult) {
      showNotification({
        message: t('change_seating_confirm'),
      });
    }
  }, [updateScreeningSeatingTypeResult, showNotification, t]);

  return [
    {
      updateScreeningSeatingTypeResult,
      loadingUpdateScreeningSeatingType,
      errorScreeningSeatingType,
      setUpdateScreeningSeatingResult,
    },
    updateScreeningSeatingType,
  ];
};

export default useScreeningUpdateSeatingType;
